import { NeedsIssueDto } from '@act/shared/data-transfer-objects';
import { getNeedsMetadata } from 'redux/slices/metaSlice';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hooks';
import { NeedsIssuesTableColumns } from './NeedIssuesColumns';
import { AdminToolSkeleton } from '../../AdminToolSkeleton';
import { IndexChildContainer } from 'react-components/member-index/indexContainer';
import { PaginatedTable, PaginatedTableProps } from '@act/storybook';
import { useState, useEffect, useMemo } from 'react';
import { NeedIssuesCreateEdit } from './NeedIssuesCreateEdit';
import { useAppDispatch } from 'redux/store-hooks';

export const NeedIssues = () => {
  const [issueCreate, setIssueCreate] = useState(false);
  const [issueEdit, setIssueEdit] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState<NeedsIssueDto | null>(
    null
  );

  const dispatch = useAppDispatch();
  const needs = metaSliceSelectors.useSelectNeedsMetadata()?.data;
  const columns = useMemo(() => {
    return NeedsIssuesTableColumns(
      needs?.categories,
      needs?.zcodes,
      needs?.activities
    );
  }, [needs]);

  useEffect(() => {
    if (!needs) {
      dispatch(getNeedsMetadata({}));
    }
  }, []);

  const NEEDS_ISSUES_ADMIN_TABLE_PROPS: PaginatedTableProps<NeedsIssueDto> = {
    data: needs?.issues,
    columnConfig: columns,
    inMemoryPagination: true,
    onRowClick: (row: NeedsIssueDto) => {
      setSelectedIssue(row);
      setIssueEdit(true);
    },
  };

  const setFormOpen = (value: boolean) => {
    if (!value) {
      setIssueEdit(false);
      setSelectedIssue(null);
    }
  };
  return (
    <>
      <AdminToolSkeleton
        title="Needs Issues"
        toolDescription="Needs issues can be viewed and updated here."
        buttonContent="Add New Needs Issue"
        variant="contained"
        onClick={() => setIssueCreate(true)}
      >
        <IndexChildContainer>
          <PaginatedTable {...NEEDS_ISSUES_ADMIN_TABLE_PROPS} />
        </IndexChildContainer>
      </AdminToolSkeleton>
      {(issueCreate || issueEdit) && (
        <NeedIssuesCreateEdit
          open={issueCreate || issueEdit}
          setOpen={issueCreate ? setIssueCreate : setFormOpen}
          isEdit={issueEdit}
          selectedIssue={selectedIssue}
        />
      )}
    </>
  );
};
